angular.module("vgresiduos").component("customReportFilterView", {
	controller: "CustomReportFilterViewCtrl",
	templateUrl: "views/customReports/components/customReportFilter/customReportFilterView_template.html",
	bindings: {
		setter: "<"
	}
});
